import SpinWheelComponent from './spinWheel.component'

export default SpinWheelComponent